import { $t } from "../../../utils/intl";
import { handleNumberField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextFieldValue } from "../text/text.config";
import { PercentFieldControl } from "../percent/PercentFieldControl/PercentFieldControl";

export const percentCompleteFieldConfig: FieldRegistryConfig<TextFieldValue> = {
  icon: "progress",
  control: (props) => (
    <PercentFieldControl {...props} placeholder={$t(fieldsText.percentPlaceholder)} type="number" />
  ),
  prefill: handleNumberField,
};
